// removeColumn — VQE-Edit edit-action: drop a SELECT item by 0-based list
// index via SR-Edit's `remove-select-item` op. Builds a `StructuralEdit` and
// delegates to `commitEdit`. SR-Edit handles the comma-stripping; this module
// only validates the index against the structure when one is supplied.
//
// PRD: Ralph/VisualQueryEditorEdit/PRD.md § Slice: Edit — add/remove SELECT
// column.

import type { QueryStructure } from '../../../../sql-resolver/types/queryStructure';
import { commitEdit, type CommitEditCtx } from '../commitEdit';

export type RemoveColumnOptions = {
  /**
   * Optional structure used for index-bounds validation. Lets the caller
   * surface a friendlier error than SR-Edit's "out of range" / "no items".
   * When omitted, validation is left to SR-Edit's applicator.
   */
  readonly structure?: QueryStructure;
};

export async function removeColumn(
  index: number,
  ctx: CommitEditCtx,
  options: RemoveColumnOptions = {},
): Promise<void> {
  if (!Number.isInteger(index) || index < 0) {
    throw new Error(`removeColumn: index must be a non-negative integer (got ${index})`);
  }
  if (options.structure) {
    const items = options.structure.selectItems ?? [];
    if (items.length === 0) {
      throw new Error('removeColumn: SELECT list is empty');
    }
    if (index >= items.length) {
      throw new Error(
        `removeColumn: index ${index} out of range (SELECT list has ${items.length} item(s))`,
      );
    }
  }
  await commitEdit({ op: 'remove-select-item', index }, ctx);
}
